<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Reguladores"
    >
        <Form
            :data="data"
            :solicitante="solicitante"
        />

        <List
            :data="data"
            :solicitante="solicitante"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { object } from '@/mixins'

export default {
    components: { Form, List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalSolicitante: null,
        solicitante: null,
    }),
    methods: {
        open(solicitante) {

            this.originalSolicitante = solicitante
            this.solicitante = this.clone(solicitante)

            this.$refs.Modal.show()
        },
        save() {

            this.originalSolicitante.reguladores = this.solicitante.reguladores

            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    },
}
</script>